import { Editor, findParentNode } from '@tiptap/react';
import { FunctionComponent, useState } from 'react';
import { getCssVar } from '../../../../../utils';
import { IconLabel, IconLabelSizes } from '../../../../IconLabel';

import classes from './TableMenu.module.scss';

export interface TableMenuSettings {
  visible: boolean;
  top: number;
  left: number;
}

interface TableMenuProps {
  editor: Editor;
  settings: TableMenuSettings;
}

interface TableInfo {
  rows: number;
  cols: number;
}

export const TableMenu: FunctionComponent<TableMenuProps> = ({ editor, settings }) => {
  const [tableInfo, setTableInfo] = useState<TableInfo>({ rows: 0, cols: 0 });

  const { visible, top, left } = settings;

  const setActiveTableInfo = () => {
    const tableNode = findParentNode((node) => node.type.name === 'table')(
      editor.state.selection
    )?.node;

    if (!tableNode) {
      return null;
    }

    const rows = tableNode.childCount;

    const cols = rows > 0 ? tableNode.child(0).childCount : 0;

    setTableInfo({ rows, cols });
  };

  editor.on('transaction', () => setActiveTableInfo());

  if (!visible) {
    return null;
  }

  return (
    <div className={classes['table-menu']} style={{ top: `${top}px`, left: `${left}px` }}>
      <IconLabel
        labelClassName={classes['table-menu__divider']}
        label={'Toggle header row'}
        labelSize={IconLabelSizes.small}
        onClick={() => editor.chain().focus().toggleHeaderRow().run()}
        disabled={tableInfo.rows <= 1}
        color={getCssVar('--base-link-text-color')}
        hoverColor={getCssVar('--base-link-text-hover-color')}
      />
      <IconLabel
        label={'Add Row'}
        labelSize={IconLabelSizes.small}
        onClick={() => editor.chain().focus().addRowAfter().run()}
        color={getCssVar('--base-link-text-color')}
        hoverColor={getCssVar('--base-link-text-hover-color')}
      />
      <IconLabel
        labelClassName={classes['table-menu__divider']}
        label={'Delete Row'}
        labelSize={IconLabelSizes.small}
        onClick={() => editor.chain().focus().deleteRow().run()}
        disabled={tableInfo.rows <= 1}
        color={getCssVar('--color-danger')}
        hoverColor={getCssVar('--color-danger-hover')}
      />
      <IconLabel
        label={'Add Column'}
        labelSize={IconLabelSizes.small}
        onClick={() => editor.chain().focus().addColumnAfter().run()}
        color={getCssVar('--base-link-text-color')}
        hoverColor={getCssVar('--base-link-text-hover-color')}
      />
      <IconLabel
        labelClassName={classes['table-menu__divider']}
        label={'Delete Column'}
        labelSize={IconLabelSizes.small}
        onClick={() => editor.chain().focus().deleteColumn().run()}
        disabled={tableInfo.cols <= 1}
        color={getCssVar('--color-danger')}
        hoverColor={getCssVar('--color-danger-hover')}
      />
      <IconLabel
        label={'Delete Table'}
        labelSize={IconLabelSizes.small}
        onClick={() => editor.chain().focus().deleteTable().run()}
        color={getCssVar('--color-danger')}
        hoverColor={getCssVar('--color-danger-hover')}
      />
    </div>
  );
};
